import React from 'react';
import '../style/formGroupTextInput.css'
import Dropzone from 'react-dropzone'
import {DROPZONE_ACCEPTED_FILES} from "../helpers/variables";
import FormGroupPlainText from "./formGroupPlainText";
import AttachmentsList from "./General/attachmentsList";
import {InfoTooltip} from 'arag-ui-lib';

const FormGroupFileInput = (props) => {
    const {label, multiple, isPlain, attachments, onAttachmentRequest} = props;

    if(isPlain) {
        return   <FormGroupPlainText
            RightWrapper={props.RightWrapper}
            rightData={props.rightData}
            LeftWrapper="col-sm-3"
            InputWrapper={props.InputWrapper}
            Label={props.Label}
            Text={(
                <AttachmentsList
                    onAttachmentRequest={onAttachmentRequest}
                    attachments={attachments ? attachments : []}
                />
            )}
        />;
    }

    return (
        <div className="form-group form-group--upload">
            <div className="col-sm-3">
                <label className="control-label.text-left formGroup-textInput-label">
                    {props.Label}
                    {props.Required?
                        <span>{' '}*</span>
                        :
                        null
                    }
                </label>
            </div>
            <div className={props.InputWrapper}>
                <Dropzone
                    onDropAccepted={props.OnDrop}
                    accept={DROPZONE_ACCEPTED_FILES}
                    className={props.DropzoneStyle}
                    multiple={multiple}
                >
                    <p>
                        {
                            label ?
                                label
                                :
                                "Try dropping some files here, or click to select files to upload."
                        }
                    </p>
                </Dropzone>
                <div className={'col-sm-12 col-sm-offset-12'} style={{bottom:'30px',right:'15px'}} >
                        <InfoTooltip
                            text="Files uploaded appear at the bottom of the application."
                            variant="info"
                            style={{}}
                            miscellaneousCharacter=""
                        />
                    </div>
            </div>
            <div className={props.RightWrapper}>{props.RightValue}</div>
        </div>
    )
};

export default FormGroupFileInput;